var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-array-view',{attrs:{"title":"PILOT BACKGROUNDS","array":_vm.backgrounds,"icon":"cci-orbit","name-key":"Name","description-key":"Description","sub-key":"LcpName","sub-conditional":"InLcp"}})}
var staticRenderFns = []

export { render, staticRenderFns }